export const ADD_FRIEND_MODAL_PATH = "/home-v2/account/friends/add/:friendId";
export const INVITE_LINK_MODAL_PATH = "/home-v2/account/friends/invite";
export const REMOVE_FRIEND_MODAL_PATH = "/home-v2/account/friends/remove/:friendId";
export const VISIBILITY_SETTINGS_MODAL_PATH = "/home-v2/account/friends/visibility-settings";

export interface FriendIdParams {
  friendId: string;
}
